@if (!theme?.enable) {
<div class="footer">
  <div class="content-element d-flex align-items-center">
    <span>Powered By</span>
    <img src="https://res.cloudinary.com/contactless/image/upload/v1609251891/planning-system/logo.svg" alt="MICEtribe logo" />
  </div>
</div>
}
@if (theme?.enable && theme?.logo) {
  <div class="footer">
    <div class="content-element d-flex align-items-center">
      <img [src]="theme.logo" style="object-fit: contain;" alt="" />
    </div>
  </div>
}